import { render, staticRenderFns } from "./LeftNews.vue?vue&type=template&id=522879ab&scoped=true&"
import script from "./LeftNews.vue?vue&type=script&lang=js&"
export * from "./LeftNews.vue?vue&type=script&lang=js&"
import style0 from "./LeftNews.vue?vue&type=style&index=0&id=522879ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522879ab",
  null
  
)

export default component.exports